module.exports = __webpack_public_path__ + "static/media/Pelipper_gaussian2.fa0bd5a8.png";